import { toggleSearchBar, toggleDropDown, searcher, searchData } from './modules/Functions';
import { imgUrl } from './modules/Arrays';
import { useState } from 'react'; 
import { Link, useHistory, useLocation } from "react-router-dom";

function Header() {

  const [bar, setBar] = useState(false);
  const [dropDown, setDropDown] = useState(false);
  const [search, setSearch] = useState('');
  const history = useHistory();
  const { pathname } = useLocation();
  const liItems = [
    {id: 1, content: "Home", active: pathname === "/" ? true : false, url: "/"},
    {id: 2, content: "Trending Albums", active: pathname.startsWith("/albums") ? true : false, url: "/albums"},
    {id: 3, content: "Trending Singles", active: pathname.startsWith("/singles") ? true : false, url: "/singles"},
    {id: 4, content: "Latest Eps", active: pathname.startsWith("/eps") ? true : false, url: "/eps"},
    {id: 5, content: "Latest Lps", active: pathname.startsWith("/lps") ? true : false, url: "/lps"}
]
  

  return (
    <header className={ bar === true ? "header search-reveal" : "header"}>
        <div className="menu-icon" onClick={() => toggleDropDown(dropDown, setDropDown)}>
            <span></span>
            <span></span>
            <span></span>  
        </div> 
        <h1 className="logo">SchemesMusic</h1>
        <form 
            className={ bar === true ? "form" : "form hide-small"} id="form"
            onSubmit={(e) => searchData(e, history, search, setSearch)}>
            <input type="text" name="search" className="input" id="search-query"
                placeholder="What are you looking for?"
                value={search}
                onChange={(e) => searcher(e, setSearch, search)}
             required />
            <button className="button" name="search-btn"> <img src={imgUrl+"search.png"} alt="some text" /> </button>
        </form>
        <div className="search-icon hide-big"  onClick={() => toggleSearchBar(bar, setBar)} >
            { bar === true ? <span>Cancel</span> : <img src={imgUrl+"search.png"} alt="some text"/>}
        </div>
        
        {/* li.active === true ? "activeli" : "" */}
        <ul className={ dropDown === true ? "drop-down-menu" : "drop-down-menu hide"}> 
            { 
                liItems.map(li => (
                    <li key={li.id} className={li.active ? "activeli" : ""}>
                        <Link to={li.url} > {li.content} </Link>
                    </li>
                ))
            }
        </ul>
    </header>
  );
}

export default Header;